"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeTokenMap = void 0;
const token_1 = require("./token");
/**
 * Creates a token map from a TokenList.
 * @param tokens
 * @returns
 */
const makeTokenMap = (tokenList) => {
    const ret = {};
    tokenList.tokens.forEach((item) => {
        ret[item.address] = new token_1.Token(item);
    });
    return ret;
};
exports.makeTokenMap = makeTokenMap;
//# sourceMappingURL=tokenList.js.map